import React from 'react';

const PAsideComponent = ({ projectId, projectData }) => {
  
  // projectData'dan projectStats'ı al, yoksa varsayılan değerler kullan
  const projectStats = projectData?.projectStats || { total: 0, current: 0, finished: 0 };
  
  // Veri dönüşümü ve güvenli erişim
  const totalTasks = parseInt(projectStats.total) || 0;
  const currentTasks = parseInt(projectStats.current) || 0;
  const finishedTasks = parseInt(projectStats.finished) || 0;
  
  // Tamamlanma oranı hesaplama
  const completionRate = totalTasks > 0 ? Math.round((finishedTasks / totalTasks) * 100) : 0;
  


  return (
    <div className="p-0">
      <h2 className="text-red-600 dark:text-violet-300 text-[11px] font-semibold mb-4">İSTATİSTİK PANELİ</h2>
      
      <div className="grid grid-cols-2 gap-4">
        {/* Toplam Görevler Kartı */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-lg p-4 border border-blue-200 dark:border-blue-700 h-20">
          <div className="flex flex-col justify-between h-full">
            <p className="text-blue-600 dark:text-blue-400 text-xs font-medium mb-1">Toplam Görevler</p>
            <p className="text-xl font-bold text-blue-700 dark:text-blue-300">{totalTasks}</p>
          </div>
        </div>

        {/* Devam Eden Görevler Kartı */}
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/20 dark:to-orange-800/20 rounded-lg p-4 border border-orange-200 dark:border-orange-700 h-20">
          <div className="flex flex-col justify-between h-full">
            <p className="text-orange-600 dark:text-orange-400 text-xs font-medium mb-1">Devam Eden</p>
            <p className="text-xl font-bold text-orange-700 dark:text-orange-300">{currentTasks}</p>
          </div>
        </div>

        {/* Tamamlanan Görevler Kartı */}
        <div className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 rounded-lg p-4 border border-green-200 dark:border-green-700 h-20">
          <div className="flex flex-col justify-between h-full">
            <p className="text-green-600 dark:text-green-400 text-xs font-medium mb-1">Tamamlanan</p>
            <p className="text-xl font-bold text-green-700 dark:text-green-300">{finishedTasks}</p>
          </div>
        </div>

        {/* Tamamlanma Oranı Kartı */}
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 rounded-lg p-4 border border-purple-200 dark:border-purple-700 h-20">
          <div className="flex flex-col justify-between h-full">
            <p className="text-purple-600 dark:text-purple-400 text-xs font-medium mb-1">Tamamlanma Oranı</p>
            <p className="text-xl font-bold text-purple-700 dark:text-purple-300">{completionRate}%</p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PAsideComponent